import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/shadowMapFragmentSoftTransparentShadow.js
var name, shader, shadowMapFragmentSoftTransparentShadowWGSL;
var init_shadowMapFragmentSoftTransparentShadow = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/shadowMapFragmentSoftTransparentShadow.js"() {
    init_shaderStore();
    name = "shadowMapFragmentSoftTransparentShadow";
    shader = `#if SM_SOFTTRANSPARENTSHADOW==1
if ((bayerDither8(floor(((fragmentInputs.position.xy)%(8.0)))))/64.0>=uniforms.softTransparentShadowSM.x*alpha) {discard;}
#endif
`;
    ShaderStore.IncludesShadersStoreWGSL[name] = shader;
    shadowMapFragmentSoftTransparentShadowWGSL = { name, shader };
  }
});

export {
  shadowMapFragmentSoftTransparentShadowWGSL,
  init_shadowMapFragmentSoftTransparentShadow
};
